




































import Vue from "vue";
import Component from "vue-class-component";

import { Deck, CustomDialogOptions, Event } from "./types";

import NavigationBar from "./components/layout/NavigationBar.vue";
import CustomDialog from "./components/customdialog/CustomDialog.vue";
import { registerEventListenerForMainApp } from "./helpers/eventListener";
import {
  readFromLocalStorage,
  saveToLocalStorage,
  SyncItem
} from "./helpers/localStorageHelper";
import continueCurrentLearningSessionIfPresent from "./helpers/continueLearningHelper";

const AppProps = Vue.extend({
  props: {
    title: String
  }
});

@Component({
  components: {
    NavigationBar,
    CustomDialog
  }
})
export default class App extends AppProps {
  propertiesToSyncWithLocalStorage = [
    { key: "decks", defaultValue: [] },
    { key: "cardLimit", defaultValue: "" }
  ] as SyncItem[];
  cardLimit = "";
  decks = [] as Deck[];
  snackbar = {
    text: "",
    snackbar: false
  };

  $refs!: {
    navbar: NavigationBar;
    customDialog: CustomDialog;
  };

  setSelectedStatusForAllDecks(status: boolean) {
    this.decks.forEach(deck => {
      deck.selected = status;
    });
  }

  created() {
    registerEventListenerForMainApp(this);

    for (const item of this.propertiesToSyncWithLocalStorage) {
      this.$watch(
        item.key,
        function() {
          saveToLocalStorage(this, item);
        },
        { deep: true }
      );
    }
  }

  mounted() {
    readFromLocalStorage(this);
    this.setSelectedStatusForAllDecks(false);
    continueCurrentLearningSessionIfPresent(
      this.$eventHub,
      this.$router,
      this.decks
    );
  }

  get numberOfSelectedDecks() {
    return this.decks.filter(deck => deck.selected).length;
  }

  swipeLeft() {
    if (this.$route.name === "Learn") {
      this.$eventHub.$emit(Event.SWIPE_LEFT_IN_LEARN);
      return;
    }
    this.$refs.navbar.hideDrawer();
  }
  swipeRight() {
    if (this.$route.name === "Learn") {
      this.$eventHub.$emit(Event.SWIPE_RIGHT_IN_LEARN);
      return;
    }
    this.$refs.navbar.showDrawer();
  }
  showCustomDialog(options: CustomDialogOptions) {
    this.$refs.customDialog.show(options);
  }
}
